module.exports = ["#fcce21","#faca1e","#f9c61d","#f9c21d","#f8be1c","#f8ba1b","#f6b418","#f6af19","#f5a918","#f4a417","#f29e17","#e69b24","#dc9930","#cd9741","#c89448","#bc9353","#ad9066","#9e8d79","#988c7e","#888892","#7886a3","#6882b3","#597fc6","#4670bc","#4067b4","#3a5fad","#345aa3","#2f539d","#2d4d96","#294a91","#21468c","#1e4087","#1e4185","#1e3f84","#1f3d85"]


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/colors.json
// module id = 270
// module chunks = 1